// NOTICE: KAPTION-INTEGRATION - Full-screen dashboard app routes
import { frontendURL } from '../../../helper/URLHelper';

const FullscreenAppView = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/dashboard-app/:appId'),
    name: 'fullscreen_dashboard_app',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: FullscreenAppView,
    props: route => ({
      appId: Number(route.params.appId),
    }),
  },
];
